import client from 'app/client';
import { AddressDto, OperationResponse } from 'api/actor';

/** Compte bancaire du gestionnaire (rattaché à sa Personne, comme les plateformes). */
export interface GestionnaireBankAccountDto {
  iban: string;
  label: string;
  bic?: string | null;
  isDefault: boolean;
}

/**
 * Création complète d'un gestionnaire acteur (user ABP + PM nature GST + Gestionnaire).
 * ORIAS optionnel pour cette nature (contrairement à Courtier / Corporate / MIA).
 */
export interface CreateGestionnaireCommand {
  companyName: string;
  address?: AddressDto;
  /** Téléphone de l'entreprise (standard), facultatif. */
  phone?: string | null;
  /** Gérant juridique : civilité et mobile, requis. */
  gerant: { civiliteId: string; phone: string };
  registrationNumber: string;
  capital: number;
  rcsCity: string;
  rcsNumber: string;
  oriasNumber?: string | null;
  rcp?: string | null;
  bankAccounts?: GestionnaireBankAccountDto[];
  complaintEmail?: string | null;
  firstName: string;
  lastName: string;
  email: string;
  username: string;
  password: string;
  plateformeIds: string[];
}

export async function createGestionnaire(
  command: CreateGestionnaireCommand,
): Promise<OperationResponse> {
  const { data } = await client.post<OperationResponse>(
    '/backoffice/gestionnaires/creation',
    command,
  );
  return data;
}
